import { WorkerSynchronizer, WorkerSynchronizerSpawner } from '@bcf-v2-platforms/platform-worker/worker-synchronizer';

export function createIsUserActiveInAppChannel(spawner: WorkerSynchronizerSpawner): WorkerSynchronizer<boolean> {
  return spawner.spawn('_userInAppActivity+isUserActiveInApp');
}
